// extracted by mini-css-extract-plugin
export default {"pageHeaderStyles":"attendance_pageHeaderStyles__H7By2","headerParentWrap":"attendance_headerParentWrap__l9LsH","headerRightSection":"attendance_headerRightSection__Z6f9R"};